/**
 * Coverage uses leaf keys; the Intent editor sometimes owns them as one group.
 * These are editor identities only. Values and evidence keys remain unchanged.
 */
export function intentEditorFieldId(fieldKey: string): string {
  const owners: Readonly<Record<string, string>> = {
    powerRequirementMW: 'powerRequirement', // SSOT-SENTINEL-OK: coverage leaf key of projectIntent.powerRequirementMW, not a Preferences field
    inServiceDate: 'timeline',
    'annualDemandUtilizationRangePct.low': 'annualDemandUtilizationRangePct',
    'annualDemandUtilizationRangePct.high': 'annualDemandUtilizationRangePct',
    'interconnectionStatus.queueStatus': 'interconnectionStatus',
    'interconnectionStatus.studyPhase': 'interconnectionStatus',
    'interconnectionStatus.queueId': 'interconnectionStatusQueueId',
    'fuelAccess.supply': 'fuelAccess',
    'fuelAccess.distanceKm': 'fuelAccess',
    'waterSource.source': 'waterSource',
    'waterSource.rightsStatus': 'waterSourceRights',
    'offtake.structure': 'offtake',
    'offtake.tenorYears': 'offtake',
    'offtake.pricePerMwhUsd': 'offtake',
    'capacityCreditIntent.target': 'capacityCreditIntent',
    'capacityCreditIntent.targetMW': 'capacityCreditIntent',
  };
  return owners[fieldKey] ?? fieldKey;
}
